module.exports = __webpack_public_path__ + "img/5.02cbf909.png";